import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {cn} from '@chekin/guestapp-ui-kit';
import {useCustomTheme} from 'context/customTheme';
import {useReservation} from 'context/reservation/useReservation';
import {useReservationSettings} from 'hooks';
import {ShareButton} from 'components/ShareButton';
import Dropdown from 'components/common/Dropdown';
import {Container, GuestInformation, StyledIcon, Wrapper} from './styled';

type Props = {
  currentGuests: number;
  totalGuests: number;
  onEditClick: () => void;
};
function HeaderGuestInformation({currentGuests, totalGuests, onEditClick}: Props) {
  const {t} = useTranslation();
  const {finalTheme} = useCustomTheme();
  const {checkCanEditReservationDetails} = useReservationSettings();
  const {allowEditingGuestNumber} = useReservation();
  const canEditReservationDetails = checkCanEditReservationDetails();
  const canEditGuestNumber = canEditReservationDetails && allowEditingGuestNumber;

  const {colors} = finalTheme;
  const dropdownOptions = useMemo(() => {
    return [
      {
        id: 1,
        label: t('edit_number_of_guests'),
        onClick: onEditClick,
      },
    ];
  }, [t, onEditClick]);

  return (
    <Wrapper
      className={cn('guest-register-view__title-wrapper', 'kiosko:absolute kiosko:top-6')}
    >
      <Container
        className={cn(
          'guest-register-view__title-container',
          'kiosko:pb-0 kiosko:pt-0 kiosko:items-center kiosko:p-14',
          'kiosko:bg-[rgba(56,91,248,0.1)]',
        )}
      >
        <Dropdown
          position="bottom left"
          options={dropdownOptions}
          disabled={!canEditGuestNumber}
          trigger={
            <GuestInformation>
              {currentGuests} {t('of')} {totalGuests}
              <span className="lowercase">{t('guests')}</span>
              {canEditGuestNumber && (
                <StyledIcon
                  name="arrow"
                  title="edit"
                  size={12}
                  color={colors.buttons.textButton}
                  className="kiosko:w-8 kiosko:h-8 kiosko:mt-0 kiosko:ml-3"
                />
              )}
            </GuestInformation>
          }
        />

        <ShareButton />
      </Container>
    </Wrapper>
  );
}

export {HeaderGuestInformation};
